'use client';

import { Refresh04Icon } from '@terra/ui-icons';
import { IconButton } from '../../components/icon-button';
import type { IconButtonSize } from '../../components/icon-button';
import { Tooltip } from '../../components/tooltip';

export type MfaRefreshIconButtonProps = {
  label: string;
  onClick: () => void;
  isLoading?: boolean;
  disabled?: boolean;
  size?: IconButtonSize;
};

export function MfaRefreshIconButton({
  label,
  onClick,
  isLoading = false,
  disabled = false,
  size = 'xs',
}: MfaRefreshIconButtonProps) {
  return (
    <Tooltip title={label}>
      <IconButton
        variant="outline"
        size={size}
        onClick={onClick}
        loading={isLoading}
        disabled={disabled}
        aria-label={label}
      >
        <Refresh04Icon />
      </IconButton>
    </Tooltip>
  );
}
